<template>
    <div>
        <table class="table table-basket-detail">
            <tbody>
                <tr v-if="item.planoInfo == null">
                    <td>
                        <figure v-if="item.component"><img :src="getImgPath(item.component.figures.small)" alt="" /></figure>
                    </td>
                    <td scope="col">{{ item.component.id }}</td>
                    <router-link class="pointer" tag="span" :to="'/product/' + item.component.id">
                        <td scope="col" class="productLink">{{ getTranslate(item.component.terms.name) }}</td>
                    </router-link>
                    <td scope="col">{{ item.quantity }}</td>
                    <td scope="col"></td>
                    <td scope="col">{{ item.unit }}</td>
                    <td scope="col">{{ displayRealPrice(item.unitPrice, order.priceShown) | CurrencyCustomPipe("en-US", currency.shortName) }}</td>
                    <td scope="col">{{ displayRealPrice(item.finalPrice, order.priceShown) | CurrencyCustomPipe("en-US", currency.shortName) }}</td>
                </tr>

                <tr v-else>
                    <td><img src="../../../../static/assets/plano.png" /></td>
                    <td scope="col" @click="toggleItem();">
                        <span class="arrow pointer">
                            <span v-show="!opened"><i class="fas fa-angle-down"></i></span>
                            <span v-show="opened"><i class="fas fa-angle-up"></i></span>
                        </span>
                        <span class="pointer">{{ item.planoInfo.id }}</span>
                    </td>
                    <router-link class="pointer" tag="span" :to="'/plano/' + item.planoInfo.id">
                        <td scope="col" class="productLink">{{ item.planoInfo.name }}</td>
                    </router-link>
                    <td scope="col"></td>
                    <td scope="col"></td>
                    <td scope="col">{{ item.unit }}</td>
                    /plano/
                    <td scope="col">{{ displayRealPrice(item.unitPrice, order.priceShown) | CurrencyCustomPipe("en-US", currency.shortName) }}</td>
                    <td scope="col">{{ displayRealPrice(item.finalPrice, order.priceShown) | CurrencyCustomPipe("en-US", currency.shortName) }}</td>
                </tr>
            </tbody>
        </table>
        <div v-if="item.planoInfo != null" v-show="opened">
            <div>
                <table class="table table-basket-detail">
                    <tbody>
                        <tr v-for="component in item.planoInfo.compositions" :key="component.id">
                            <td scope="col">{{ diamRef(component) && diamRef(component).componentProperty.value }}</td>
                            <router-link class="pointer" tag="span" :to="'/product/' + component.component.id">
                                <td scope="col" class="productLink">{{ getTranslate(component.component.terms.name) }}</td>
                            </router-link>
                            <td scope="col">{{ component.quantity }}</td>
                            <td scope="col"></td>
                            <td scope="col"></td>
                            <td scope="col"></td>
                            <td scope="col"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Globals from "../../globals";
export default {
    name: "OrderBasketItem",
    props: ["item", "currency"],
    computed: {
        ...mapGetters("order", {
            order: "details/getOrder"
        })
    },
    data() {
        return {
            opened: false
        };
    },
    methods: {
        toggleItem() {
            this.opened = !this.opened;
        },
        diamRef(component) {
            return component.component.infosArticle && (component.component.infosArticle.diam_ref1 || component.component.infosArticle.diam_ref2);
        },
        getImgPath(imgPath) {
            return Globals.getBaseUrl() + imgPath;
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";

.table-basket-detail {
    &.sub-basket {
        td {
            &:nth-child(1) {
                padding-left: 30px;
            }
        }
    }
    tbody {
        tr {
            td {
                border: none;
                @extend %primary-text;
                &:nth-child(1) {
                    width: 15%;
                    padding-left: 20px;
                }
                &:nth-child(2) {
                    width: 35%;
                    padding-left: 0;
                }
                &:nth-child(3) {
                    width: 10%;
                    text-align: center;
                }
                &:nth-child(4) {
                    width: 10px;
                    padding-left: 0;
                }
                &:nth-child(5) {
                    width: 10%;
                    text-align: center;
                }
                &:nth-child(6) {
                    width: 15%;
                    padding-left: 0;
                }
                &:nth-child(7) {
                    width: 15%;
                    text-align: right;
                    padding-right: 3px;
                }
                &.productLink {
                    color: $color4;
                }
                figure {
                    img {
                        max-width: 110px;
                        @media only screen and (max-width: 767px) {
                            max-width: 90px;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// OrderBasketItem.vue?fa37bd10